const replaceWithNonBreakingHyphens = (text: string) =>
  text.replaceAll('-', '‑');

export default replaceWithNonBreakingHyphens;
